var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisteredReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "25 -20 132 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,136.000000) scale(0.130000,-0.130000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435 1128 c-5 -48 -55 -591 -55 -603 0 -3 -41 -5 -91 -5 l-91 0 4 -104 c3 -118 16 -147 79 -178 30 -16 68 -18 338 -18 l304 0 43 25 c64 38 69 60 99 465 14 195 28 381 32 413 l6 57 -331 0 -331 0 -6 -52z m595 -40 c0 -79 -51 -707 -60 -740 -20 -70 -105 -87 -150 -31 -17 21 -20 41 -20 114 l0 89 -181 0 -181 0 6 43 c3 23 15 152 27 287 11 135 23 251 25 258 3 9 65 12 269 12 l265 0 0 -32z m-288 -700 c2 -40 8 -81 12 -91 8 -17 -3 -18 -219 -15 l-227 3 -24 28 c-20 23 -24 39 -24 88 l0 59 239 0 239 0 4 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 970 l0 -30 149 0 149 0 4 30 5 30 -154 0 -153 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 850 l0 -30 149 0 c146 0 149 0 155 23 3 12 6 25 6 30 0 4 -70 7 -155 7 l-155 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 730 c0 -26 3 -30 29 -30 21 0 30 6 35 23 9 35 8 37 -29 37 -32 0 -35 -2 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 730 l0 -30 60 0 c33 0 60 3 60 8 0 4 3 17 6 30 6 21 4 22 -60 22 l-66 0 0 -30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredReceipt);
export default __webpack_public_path__ + "static/media/RegisteredReceipt.418bb9c15b026d7dfc7ce443d722e03e.svg";
export { ForwardRef as ReactComponent };